<div class="mb-8">
  <h1 class="text-3xl font-bold text-gray-800 mb-2">{{ title }}</h1>
  <p class="text-gray-600"><ng-content></ng-content></p>
</div>
